import { createFileRoute } from '@tanstack/react-router';

import DirectiveList from '~/app/directives/DirectiveList';

export interface DirectivesSearchParams {
	directive?: string;
	createDirective?: boolean;
}

export const Route = createFileRoute('/_app/home/directives')({
	validateSearch: (search): DirectivesSearchParams => {
		return {
			directive: typeof search.directive === 'string' ? search.directive : undefined,
			createDirective: search.createDirective === true || search.createDirective === 'true'
		} as DirectivesSearchParams;
	},
	beforeLoad: () => {
		return {
			getTitle: 'Directives'
		};
	},
	component: DirectiveList
});
